import React, { useEffect, useState, useCallback, useRef } from 'react';
import * as XLSX from 'xlsx';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import RevenueTable from './RevenueTable';
import RevenueShow from './RevenueShow';
import RevenueShowForYearly from './RevenueShowForYearly';
import { getKoreaRevenueDetails, handleLoader } from '../../../../redux/actions/KoreaRevenueAction';
import { setCurrencyFormatInWon, setCurrencyFormat } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import {
  filterShowWiseForCurrency as filterShowWise,
  sortType
} from '../../helper';

const Revenue = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');

  const { revenueData, salesChannelFilterData, isLoading } = useSelector(
    ({ koreaRevenueReducer, marketPlaceReducer }) =>
    ({
      revenueData: koreaRevenueReducer?.revenueData,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: koreaRevenueReducer?.isLoading
    })
  );

  const salesChannelRef = useRef({})

  const [dataToShow, setDataToShow] = useState(revenueData?.modal?.data);
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0])
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [month1, setMonth1] = useState({ year: currentYear });
  const [tempMonth1, setTempMonth1] = useState({ year: currentYear })

  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const exportToExcel = (data, filename) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Report");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: { top: 120, fontWeight: "bold" },
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvYear');
    const dvChartF = document.getElementById('dvSelectYear');
    const dvChartV = document.getElementById('dvChartView');
    dvTb.style.display = "none";
    dvChartF.style.display = "none";
    dvChartV.style.display = "none";
    const element = container.current || document.body;

    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
      // margin: "2cm",
      // forcePageBreak: ".page-break",
      //   landscape: true,
      //  multiPage: true,
      fileName: `Korea Revenue Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";
    dvChartF.style.display = "block";
    dvChartV.style.display = "block";
  }


  const callApi = () => {
    dispatch(handleLoader(true));
    dispatch(getKoreaRevenueDetails());
  }

  const handleYearMonthChange = ({ field, value }) => {
    setTempMonth1({ ...tempMonth1, [field]: value?.value });
  }

  const changeFilter = (value) => {
    setCurrentlyShow(value)
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(revenueData?.modal?.data);
  }, [revenueData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  const dataToShowForDatesSelected = dataToShow || [];

  const tableHeader = [{
    Header: 'Customer Name',
    accessor: 'customerName',
    disableGlobalFilter: false,
    width: 220,
    sortType
  },
  {
    Header: 'Type',
    accessor: 'type',
    disableGlobalFilter: false,
    width: 120,
    sortType
  },
  {
    Header: `Jan-${tempMonth1.year}`,
    accessor: 'jan',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    sortType,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { jan } = original
      return setCurrencyFormatInWon(Number(jan).toFixed(0), true)
    },
  },
  {
    Header: `Feb-${tempMonth1.year}`,
    accessor: 'feb',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { feb } = original
      return setCurrencyFormatInWon(Number(feb).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Mar-${tempMonth1.year}`,
    accessor: 'mar',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { mar } = original
      return setCurrencyFormatInWon(Number(mar).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Apr-${tempMonth1.year}`,
    accessor: 'apr',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { apr } = original
      return setCurrencyFormatInWon(Number(apr).toFixed(0), true)
    },
    sortType
  }, {
    Header: `May-${tempMonth1.year}`,
    accessor: 'may',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { may } = original
      return setCurrencyFormatInWon(Number(may).toFixed(0), true)
    },
    sortType
  }
    , {
    Header: `Jun-${tempMonth1.year}`,
    accessor: 'jun',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { jun } = original
      return setCurrencyFormatInWon(Number(jun).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Jul-${tempMonth1.year}`,
    accessor: 'jul',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { jul } = original
      return setCurrencyFormatInWon(Number(jul).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Aug-${tempMonth1.year}`,
    accessor: 'aug',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { aug } = original
      return setCurrencyFormatInWon(Number(aug).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Sep-${tempMonth1.year}`,
    accessor: 'sept',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { sept } = original
      return setCurrencyFormatInWon(Number(sept).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Oct-${tempMonth1.year}`,
    accessor: 'oct',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { oct } = original
      return setCurrencyFormatInWon(Number(oct).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Nov-${tempMonth1.year}`,
    accessor: 'nov',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { nov } = original
      return setCurrencyFormatInWon(Number(nov).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Dec-${tempMonth1.year}`,
    accessor: 'dec',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { dec } = original
      return setCurrencyFormatInWon(Number(dec).toFixed(0), true)
    },
    sortType
  }]

  const tableHeaderForDollor = [{
    Header: 'Customer Name',
    accessor: 'customerName',
    disableGlobalFilter: false,
    width: 220,
    sortType
  },
  {
    Header: 'Type',
    accessor: 'type',
    disableGlobalFilter: false,
    width: 120,
    sortType
  },
  {
    Header: `Jan-${tempMonth1.year}`,
    accessor: 'janDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    sortType,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { janDollarConverted } = original
      return setCurrencyFormat(Number(janDollarConverted).toFixed(0), true)
    },
  },
  {
    Header: `Feb-${tempMonth1.year}`,
    accessor: 'febDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { febDollarConverted } = original
      return setCurrencyFormat(Number(febDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Mar-${tempMonth1.year}`,
    accessor: 'marDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { marDollarConverted } = original
      return setCurrencyFormat(Number(marDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Apr-${tempMonth1.year}`,
    accessor: 'aprDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { aprDollarConverted } = original
      return setCurrencyFormat(Number(aprDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `May-${tempMonth1.year}`,
    accessor: 'mayDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { mayDollarConverted } = original
      return setCurrencyFormat(Number(mayDollarConverted).toFixed(0), true)
    },
    sortType
  }
    , {
    Header: `Jun-${tempMonth1.year}`,
    accessor: 'junDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { junDollarConverted } = original
      return setCurrencyFormat(Number(junDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Jul-${tempMonth1.year}`,
    accessor: 'julDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { julDollarConverted } = original
      return setCurrencyFormat(Number(julDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Aug-${tempMonth1.year}`,
    accessor: 'augDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { augDollarConverted } = original
      return setCurrencyFormat(Number(augDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Sep-${tempMonth1.year}`,
    accessor: 'septDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { septDollarConverted } = original
      return setCurrencyFormat(Number(septDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Oct-${tempMonth1.year}`,
    accessor: 'octDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { octDollarConverted } = original
      return setCurrencyFormat(Number(octDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Nov-${tempMonth1.year}`,
    accessor: 'novDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { novDollarConverted } = original
      return setCurrencyFormat(Number(novDollarConverted).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Dec-${tempMonth1.year}`,
    accessor: 'decDollarConverted',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { decDollarConverted } = original
      return setCurrencyFormat(Number(decDollarConverted).toFixed(0), true)
    },
    sortType
  }]

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
        disabled={!dataToShowForDatesSelected?.length}
      >
        View Report
      </button>
    </div>
  )
  const modalData = dataToShowForDatesSelected?.map(item => ({
    ...item,
    jan: Number(item.jan).toFixed(2),
    feb: Number(item.feb).toFixed(2),
    mar: Number(item.mar).toFixed(2),
    apr: Number(item.apr).toFixed(2),
    may: Number(item.may).toFixed(2),
    jun: Number(item.jun).toFixed(2),
    jul: Number(item.jul).toFixed(2),
    aug: Number(item.aug).toFixed(2),
    sept: Number(item.sept).toFixed(2),
    oct: Number(item.oct).toFixed(2),
    nov: Number(item.nov).toFixed(2),
    dec: Number(item.dec).toFixed(2),
    janDollarConverted: Number(item.janDollarConverted).toFixed(2),
    febDollarConverted: Number(item.febDollarConverted).toFixed(2),
    marDollarConverted: Number(item.marDollarConverted).toFixed(2),
    aprDollarConverted: Number(item.aprDollarConverted).toFixed(2),
    mayDollarConverted: Number(item.mayDollarConverted).toFixed(2),
    junDollarConverted: Number(item.junDollarConverted).toFixed(2),
    julDollarConverted: Number(item.julDollarConverted).toFixed(2),
    augDollarConverted: Number(item.augDollarConverted).toFixed(2),
    septDollarConverted: Number(item.septDollarConverted).toFixed(2),
    octDollarConverted: Number(item.octDollarConverted).toFixed(2),
    novDollarConverted: Number(item.novDollarConverted).toFixed(2),
    decDollarConverted: Number(item.decDollarConverted).toFixed(2),
  }))



  let dataToShowForTable = modalData || [];
  dataToShowForTable = dataToShowForTable.filter(item => item.salesYear === `${tempMonth1.year}`)

  const excelData = dataToShowForTable?.map(item => ({
    ...item,
    jan: setCurrencyFormatInWon(Number(item.jan).toFixed(2), true),
    feb: setCurrencyFormatInWon(Number(item.feb).toFixed(2), true),
    mar: setCurrencyFormatInWon(Number(item.mar).toFixed(2), true),
    apr: setCurrencyFormatInWon(Number(item.apr).toFixed(2), true),
    may: setCurrencyFormatInWon(Number(item.may).toFixed(2), true),
    jun: setCurrencyFormatInWon(Number(item.jun).toFixed(2), true),
    jul: setCurrencyFormatInWon(Number(item.jul).toFixed(2), true),
    aug: setCurrencyFormatInWon(Number(item.aug).toFixed(2), true),
    sept: setCurrencyFormatInWon(Number(item.sept).toFixed(2), true),
    oct: setCurrencyFormatInWon(Number(item.oct).toFixed(2), true),
    nov: setCurrencyFormatInWon(Number(item.nov).toFixed(2), true),
    dec: setCurrencyFormatInWon(Number(item.dec).toFixed(2), true),
    janDollarConverted: setCurrencyFormat(Number(item.janDollarConverted).toFixed(2), true),
    febDollarConverted: setCurrencyFormat(Number(item.febDollarConverted).toFixed(2), true),
    marDollarConverted: setCurrencyFormat(Number(item.marDollarConverted).toFixed(2), true),
    aprDollarConverted: setCurrencyFormat(Number(item.aprDollarConverted).toFixed(2), true),
    mayDollarConverted: setCurrencyFormat(Number(item.mayDollarConverted).toFixed(2), true),
    junDollarConverted: setCurrencyFormat(Number(item.junDollarConverted).toFixed(2), true),
    julDollarConverted: setCurrencyFormat(Number(item.julDollarConverted).toFixed(2), true),
    augDollarConverted: setCurrencyFormat(Number(item.augDollarConverted).toFixed(2), true),
    septDollarConverted: setCurrencyFormat(Number(item.septDollarConverted).toFixed(2), true),
    octDollarConverted: setCurrencyFormat(Number(item.octDollarConverted).toFixed(2), true),
    novDollarConverted: setCurrencyFormat(Number(item.novDollarConverted).toFixed(2), true),
    decDollarConverted: setCurrencyFormat(Number(item.decDollarConverted).toFixed(2), true),
  }))

  const excelTableHeader = currentlyShow?.value === 'Won' ? tableHeader : tableHeaderForDollor
  const excelFileName = `Korea Revenue (${currentlyShow?.value})`

  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Korea Revenue</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
                <Col sm="6" md="3">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Currency</span>
                    <div className="form__form-group-field">
                      <Select
                        value={currentlyShow}
                        options={filterShowWise}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-show-based"
                        onChange={value => changeFilter(value)}
                        classNamePrefix="react-select"
                      />
                    </div>

                  </div>
                </Col>
                <Col md="9" className='text-right'>
                  <button className="btn btn-sm btn-primary
                                             apply-date-button" style={{ marginTop: 40 }} type="button"
                    title='Export to pdf' disabled={isLoading}
                    onClick={exportToPDF}>Export PDF</button></Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
        <Card className="pb-3">
          <CardBody className="">
            <div className="top-location"
              style={{ minHeight: '400' }}>
              <div >
                {isLoading ? <div style={{ minHeight: '200px' }}
                  className="row align-items-center justify-content-center">
                  <SmallLoader loading={isLoading} />
                </div>
                  : <RevenueShowForYearly
                    dir={rtl.direction}
                    data={dataToShowForDatesSelected}
                    title='Revenue Chart'
                    viewReportButton={viewReportButton}
                    selectedYear={tempMonth1.year}
                    currentlyShow={currentlyShow}
                  />}
              </div>
            </div>
          </CardBody>
        </Card>
        <Card className="pb-3">
          <CardBody className="">
            <div className="top-location"
              style={{ minHeight: '400' }}>
              <div >
                {isLoading ? <div style={{ minHeight: '200px' }}
                  className="row align-items-center justify-content-center">
                  <SmallLoader loading={isLoading} />
                </div>
                  : <RevenueShow
                    dir={rtl.direction}
                    dataToShow={dataToShowForDatesSelected}
                    title='Revenue Chart'
                    viewReportButton={viewReportButton}
                    selectedYear={tempMonth1.year}
                    currentlyShow={currentlyShow}
                  />}
              </div>
            </div>
          </CardBody>
        </Card>
        <Card className="pb-3">
          <CardBody className="">
            <Row className="justify-content-space-between align-items-center">
              <Col sm="12" md="7">
                <div className="card__title row " style={{ position: 'relative' }} >
                  <h5 className="bold-text col-md-5">Korea Revenue Table</h5>
                </div>
              </Col>
              <Col sm="12" md="2" style={{ marginTop: '35px', textAlign: 'right' }} id='dvYear'>Select Year :</Col>
              <Col sm="12" md="1" style={{ marginTop: '35px' }} id='dvSelectYear'>
                <Select
                  value={{ value: tempMonth1?.year, label: tempMonth1?.year }}
                  options={yearOptions}
                  clearable={false}
                  placeholder="Select Year"
                  className="select_filter-120"
                  onChange={value => handleYearMonthChange({ field: 'year', value })}
                  classNamePrefix="react-select"
                />
                {/* <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />                   
                  </Row> */}
              </Col>
              <Col sm="12" md="2" style={{ textAlign: 'right' }}>
                <div className="ExcelTable" id='dvChartView'>
                  <Button
                    disabled={!excelData.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={() => exportToExcel(excelData, excelFileName)}
                  >
                    Download
                  </Button>
                  {/* <ExcelFile
                    filename={excelFileName}
                    element={
                      <Button disabled={!excelData.length}
                        className="download-monthly-sub-order-report btn-primary btn btn-sm">
                        Download
                      </Button>
                    }
                  >
                    <ExcelSheet data={excelData} name="report">
                      {excelTableHeader?.map(column => (
                        <ExcelColumn
                          key={`${column.Header}`}
                          label={column.Header}
                          value={column.accessor} />
                      ))}
                    </ExcelSheet>
                  </ExcelFile> */}
                </div>
              </Col>
            </Row>
            <div className="top-location"
              style={{ minHeight: '400' }}>
              <div >
                {isLoading ? <div style={{ minHeight: '200px' }}
                  className="row align-items-center justify-content-center">
                  <SmallLoader loading={isLoading} />
                </div>
                  : <RevenueTable
                    dataToShowForDatesSelected={dataToShowForTable}
                    tableHeaderData={currentlyShow?.value === 'Won' ? tableHeader : tableHeaderForDollor}
                    currentlyShow={currentlyShow}
                  />}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
      <ViewSalesReportModal
        modalData={modalData}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        title='Korea Revenue Report'
        fileName='Korea Revenue Report'
      />
    </Container>
  );
};

Revenue.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(Revenue);